import { Job } from '@vromo/models';

/** tells if job belongs to 'Royal Automobile Club of Western Australia' customer */
export function racJob(job: Job): boolean {
    return (
        job.group != null && [4691637532, 4734392243, 4739928895, 4968359240].includes(job.group)
    );
}

/** tells if job belongs to 'Royal Automobile Club of Western Australia' - 'Australian Automobile Club' customer */
export function racAaacJob(job: Job): boolean {
    return job.campaign?.id === 5951979432;
}

/** check given job belongs to 'Royal Automobile Club of Western Australia'  */
export const isRacJob = (job: Job): boolean => (racJob(job) || racAaacJob(job))